import { Link } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { fetchEvents } from "../../controller/c_events";
import { getAllMembers, getCountryStats } from "../../controller/c_member";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function AdminOverview() {
  const token = useSelector((state) => state.auth.login.token);

  const [stats, setStats] = useState({
    users: 0,
    enquiry: 0,
    events: 0,
    subscribers: 0,
  });

  const [countryStats, setCountryStats] = useState([]);

  const loadStats = useCallback(async () => {
    try {
      const evts = await fetchEvents(token);
      setStats((item) => ({ ...item, events: evts.length }));

      const mems = await getAllMembers();
      setStats((item) => ({ ...item, users: mems.length }));

      const countries = await getCountryStats();

      if (countries.msgtype === "success") {
        const cleaned = countries.data
          .map((c) => ({
            country: c.country.trim(),
            ccount: c.ccount,
          }))
          .sort((a, b) => b.ccount - a.ccount);

        setCountryStats(cleaned);
      }
    } catch (err) {
      console.error(err);
    }
  }, [token]);

  useEffect(() => {
    loadStats();
    const id = setInterval(loadStats, 10000);
    return () => clearInterval(id);
  }, [loadStats]);

  const chartData = {
    labels: countryStats.map((c) => c.country),
    datasets: [
      {
        label: "Registrations",
        data: countryStats.map((c) => c.ccount),
        backgroundColor: "#0f6b40",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: "white",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "white",
        },
      },
      y: {
        ticks: {
          color: "white",
        },
      },
    },
  };

  return (
    <div className="text-light">
      <h1 className="h3 fw-bold mb-3">Overview</h1>

      {/* Stats Cards */}
      <div className="row g-3">
        <div className="col-12 col-md-6 col-xl-3">
          <div className="card admin-card">
            <div className="card-body p-4">
              <div className="text-white small">Total Users</div>
              <div className="display-4 fw-bold custom-text">{stats.users}</div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-xl-3">
          <div className="card admin-card">
            <div className="card-body p-4">
              <div className="text-white small">Enquiries</div>
              <div className="display-4 custom-text fw-bold">{stats.enquiry}</div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-xl-3">
          <div className="card admin-card">
            <div className="card-body p-4">
              <div className="text-white small">Upcoming Events</div>
              <div className="display-4 custom-text fw-bold">{stats.events}</div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-xl-3">
          <div className="card admin-card">
            <div className="card-body p-4">
              <div className="text-white small">Subscribers</div>
              <div className="display-4 custom-text fw-bold">
                {stats.subscribers}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Graph Section */}
      <div className="row g-3 mt-3">
        <div className="col-12 col-lg-7">
          <div className="card admin-card">
            <div className="card-body p-4">
              <h2 className="h6 fw-bold mb-3 text-white">
                Registrations by Country
              </h2>

              <Bar data={chartData} options={chartOptions} />
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="col-12 col-lg-5">
          <div className="card admin-card">
            <div className="card-body p-4">
              <h2 className="h6 fw-bold mb-3 text-white">Quick Actions</h2>
              <div className="d-grid gap-2">
                <Link to="/admin/users" className="btn btn-outline-light">
                  <i className="bi bi-person-plus me-2" /> Users
                </Link>

                <Link to="/admin/events" className="btn btn-outline-light">
                  <i className="bi bi-calendar-plus me-2" /> Events
                </Link>

                <Link className="btn btn-outline-light">
                  <i className="bi bi-envelope-paper me-2" /> Send Newsletter
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}